import moment from 'moment';
import { range } from 'lodash';
import { getCurrentDate } from './datetime';

export const getYearOptionsForSelect = (): {
  value: string;
  label: string;
}[] => {
  const currentMonthDay = getCurrentDate('MM-DD');
  const currentYear = moment().year();
  const optionYears = range(currentYear + 1, currentYear - 6);
  return optionYears.map(year => ({
    value: `${year}-${currentMonthDay}`,
    label: `${year - 1}-${year}`,
  }));
};
